// extracted by mini-css-extract-plugin
module.exports = {"chips-panel":"ChipsPanel_chips-panel__3F5YI","clear-filters-button":"ChipsPanel_clear-filters-button__1fadO"};